var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import _ from 'lodash';
import assert from 'assert';

import PropertyInfo from './PropertyInfo';
import ScheduledItem from './ScheduledItem';
import DataItem from './DataItem';

var Schedule = function () {
    function Schedule(scheduleDescriptorObj, onChange, scheduleOnChange, itemOnChange) {
        var _this = this;

        _classCallCheck(this, Schedule);

        this._descriptor = scheduleDescriptorObj;
        this._onChange = typeof onChange === 'function' ? onChange : _.noop;
        var scheduleChange = typeof scheduleOnChange === 'function' ? scheduleOnChange : _.noop;
        this._scheduleOnChange = function () {
            /*  Wrapper to alert this class that a child has updated, first call the child's callback then this classes
             callback.
             */
            scheduleChange();
            _this._onChange();
            _this._hasScheduleChanged = true;
        };
        this._itemOnChange = typeof itemOnChange === 'function' ? itemOnChange : _.noop;
        this._hasScheduleChanged = false;

        this._propertyInfos = _(scheduleDescriptorObj.propertyInfos).map(function (propDefinition) {
            return new PropertyInfo(propDefinition, _this);
        }).sortBy(function (propInfo) {
            return propInfo.getOrder();
        }).valueOf();
        this._scheduledItems = _(scheduleDescriptorObj.scheduleItems).map(function (si) {
            return new ScheduledItem(si, _this._propertyInfos, _this._scheduleOnChange, _this._itemOnChange);
        }).sortBy(function (item) {
            return item.getId();
        }).valueOf();
    }

    _createClass(Schedule, [{
        key: 'describe',
        value: function describe() {
            return this._descriptor;
        }
    }, {
        key: 'getDisplayName',
        value: function getDisplayName() {
            return this._descriptor.displayName;
        }
    }, {
        key: 'getPattern',
        value: function getPattern() {
            return this._descriptor.patternName;
        }
    }, {
        key: 'getProperties',
        value: function getProperties() {
            return this._propertyInfos;
        }
    }, {
        key: 'getScheduledItems',
        value: function getScheduledItems() {
            return this._scheduledItems;
        }
    }, {
        key: 'createNewItem',
        value: function createNewItem() {
            var _this2 = this;

            return new ScheduledItem({
                '@deserialization-class': this._descriptor.deserializationClass, // Passed from backend, needs to be set on an item
                itemNumber: null,
                itemData: _.zipObject(this._propertyInfos.map(function (pi) {
                    return [pi.getName(), pi.getDefaultValue(_this2._itemOnChange).describe()];
                }))
            }, this._propertyInfos);
        }
    }, {
        key: 'add',
        value: function add(item) {
            assert(item instanceof ScheduledItem);

            this._descriptor.scheduleItems.push(item.describe());
            this._scheduledItems.push(item);

            this._onChange();
            this._hasScheduleChanged = false;
        }
    }, {
        key: 'dataItemIsUniqueInSchedule',
        value: function dataItemIsUniqueInSchedule(item) {
            assert(item instanceof DataItem);

            return this.getScheduledItems().every(function (scheduledItem) {
                var samePropertyItem = scheduledItem.findItemByProperty(item);
                return samePropertyItem === item || samePropertyItem.getValue() !== item.getValue();
            });
        }
    }, {
        key: 'remove',
        value: function remove(scheduledItem) {
            this._descriptor.scheduleItems.splice(scheduledItem._findIn(this._descriptor.scheduleItems), 1);
            this._scheduledItems.splice(this._scheduledItems.indexOf(scheduledItem), 1);

            this._onChange();
            this._hasScheduleChanged = true;
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            return this.getScheduledItems().every(function (item) {
                return item.isValid();
            });
        }
    }, {
        key: 'getChangedStatus',
        value: function getChangedStatus() {
            return this._hasScheduleChanged;
        }
    }, {
        key: 'resetChangedStatus',
        value: function resetChangedStatus() {
            this._hasScheduleChanged = false;
        }
    }]);

    return Schedule;
}();

export default Schedule;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/models/schedules/Schedule.js
// module id = 805
// module chunks = 0